const HealthPage = () => {
    return (
        <div>
            Healthy
        </div>
    );
}
export default HealthPage;